import { NewsletterFormProps } from 'components/Layout/Footer/NewsletterForm/NewsletterForm';
import { Webline } from 'components/Layout/Webline/Webline';
import { useFooterSetting } from 'connectors/footerSetting/footerSetting';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import dynamic from 'next/dynamic';

/*
 * Currently NOT used in any domain
 * External scripts (Targito) used
 */
const NewsletterForm = dynamic<NewsletterFormProps>(() =>
    import('components/Layout/Footer/NewsletterForm/NewsletterForm').then((component) => component.NewsletterForm),
);

export const NewsletterFormFooterBlock: FC = () => {
    const isDesktop = useMediaMin('vl');
    const footerSetting = useFooterSetting();
    const shouldDisplayNewsletterForm =
        footerSetting !== null && footerSetting.newsletterImage !== null && (isDesktop || isDesktop === undefined);

    if (shouldDisplayNewsletterForm) {
        return (
            <Webline className="hidden vl:block" type="light">
                <NewsletterForm footerSetting={footerSetting!} />
            </Webline>
        );
    }

    return null;
};
